import moment from "moment";
import { preDefinedLabelsByDateLabel } from "./preDefinedLabelsByDateLabel";
import { PreDefinedRange } from "../constants/types";
import { DateLabel } from "@/services/cloudchipr.api";

const getQuarterRange = (
  quarterStartMonth: number,
  dateLabel: DateLabel,
): PreDefinedRange | null => {
  const currentQuarter = getFQuarterByStartMonth(
    moment().month() + 1,
    quarterStartMonth,
  );

  let dateTo;
  let dateFrom;

  if (dateLabel === "last_quarter") {
    dateFrom = moment(currentQuarter.start)
      .subtract(3, "month")
      .startOf("month");

    dateTo = moment(currentQuarter.end).subtract(3, "month").endOf("month");
  } else if (dateLabel === "quarter_to_date") {
    dateFrom = moment(currentQuarter.start).startOf("month");
    dateTo = moment().endOf("day");
  } else {
    return null;
  }

  return {
    dateLabel,
    dateTo: dateTo?.format(),
    dateFrom: dateFrom?.format(),
    label: preDefinedLabelsByDateLabel[dateLabel].long,
    shortLabel: preDefinedLabelsByDateLabel[dateLabel].short,
  };
};

export const getFQuarterByStartMonth = (
  currentMonth: number,
  startMonth: number = 1,
) => {
  const shiftedMonth = (currentMonth - startMonth + 12) % 12;
  const quarter = Math.floor(shiftedMonth / 3) + 1;

  const start = moment()
    .month(startMonth - 1 + (quarter - 1) * 3)
    .startOf("month");

  const end = moment(start).add(2, "months").endOf("month");

  return {
    quarter,
    start: start.toDate(),
    end: end.toDate(),
  };
};

export const getQuarterlyPreDefinedRange = (
  label: DateLabel,
  startFromMonth?: number,
): PreDefinedRange | null => getQuarterRange(startFromMonth ?? 1, label);
